<template>
    <div>
        <div v-for="(item, index) in data.GradedCommissionList" :key="index">
          {{item.CommissionText}}
          <span class="cs-gradedCommission-range">{{getRangeDesc(item)}}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
  .cs-gradedCommission-range{
    color: #909399;
  }
</style>

<script>
import { getCurrencyMark } from "../../../config/mUtils.js";
export default {
  props: {
    data: {},
    columnData:{},
    status: {}
  },
  data() {
    return {
    }
  },
  components: {},
  created() {
    
  },
  methods: {
    getRangeDesc(item){
      if (!!this.data){
        let currencyMark = getCurrencyMark(this.data.CountryCode);
        let min = item.MinValue;
        if (!!min && min != 0){
          min = new Intl.NumberFormat('en-IN').format(min);
          min = currencyMark + min;
        }else{
          min = "";
        }
        let max = item.MaxValue;
        if (!!max && max != 0){
          max = new Intl.NumberFormat('en-IN').format(max);
          max = currencyMark + max;
        }else{
          max = "";
        }
        return "(" + min + " - " + max + ")";
      }
      return "";
    }
  },
  watch: {
    data: function() {
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/gradedCommissionCell.vue